import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  inviterLink: {
    ...reskinStyles(theme, theme.actionStyles.link),
    color: theme.colors.action_text
  }
});

export default makeStyles(styles);
